<div #miniMap id="mini-map" class="mini-map"></div>
